type PanelWithAzimuth = {
  azimuth?: number | string;
};

const parseAzimuth = (azimuth: number | string | undefined) => {
  if (azimuth === undefined || azimuth === '') {
    return undefined;
  }

  const parsedAzimuth = typeof azimuth === 'number' ? azimuth : Number(azimuth.replace(',', '.'));
  return Number.isFinite(parsedAzimuth) ? parsedAzimuth : undefined;
};

export const hasNorthFacingAzimuth = (panels: PanelWithAzimuth[] | undefined) =>
  panels?.some((panel) => {
    const azimuth = parseAzimuth(panel.azimuth);
    return azimuth !== undefined && (azimuth < 45 || azimuth > 315);
  }) ?? false;
